'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pdf = require('./Pdf');

var _Pdf2 = _interopRequireDefault(_Pdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pdf2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-pdf-js/lib/index.js
// module id = 339
// module chunks = 156897593687669